/* ============================================================
   PARCU — pinning the category bar on collection pages

   parcu-header.js inserts the bar directly after the header, so in
   document order it comes BEFORE the free shipping banner. That
   rules out position:sticky on its own: sticky pins as soon as the
   element reaches its offset, which happened while the banner was
   still on screen, and the bar then sat on top of it.

   So the bar stays in normal flow until the banner has scrolled
   past, and only then is it fixed to the top. The switch takes it
   out of the flow, so the banner below it takes an equal margin at
   the same moment and nothing on the page moves. parcu-lines2.css
   holds both halves of that.

   The threshold is measured, not assumed, because the header and
   the banner are both theme sections whose heights change with the
   viewport. It is only measured while the bar is unpinned: once the
   bar is fixed the banner has moved up by the bar height and would
   give a different answer every time.
   ============================================================ */

(function () {
    'use strict';

    var root = document.documentElement;
    var mark = null;
    var ticking = false;

    function measure() {
        if (root.classList.contains('parcu-barstick')) return;
        var announce = document.querySelector('[data-parcu-announce]');
        if (!announce) return;          /* parcu-header.js has not run yet */
        mark = Math.round(announce.getBoundingClientRect().bottom + window.pageYOffset);
    }

    function update() {
        if (!root.classList.contains('parcu-listing')) return;
        if (mark === null) measure();
        if (mark === null) return;
        root.classList.toggle('parcu-barstick', window.pageYOffset >= mark);
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
            update();
            ticking = false;
        });
    }

    function refresh() {
        measure();
        update();
    }

    function boot() {
        /* This file is loaded before parcu-header.js, which is what
           builds the bar and tags the sections, so the first measure
           usually finds nothing. The load pass is the one that
           counts, and a scroll before then measures on demand. */
        refresh();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', refresh);
        window.addEventListener('load', refresh);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();